import React, {Component} from 'react'
import Helmet from 'react-helmet'
import {connect} from 'react-redux'
import Elm from 'react-elm-components'
import SimplifiedRequestComponent from '../../elm/src/SimplifiedRequest.elm'
import {Grid} from 'react-bootstrap'
import config from '../config'
import icons from '../core/components/Icon.less'

class SimplifiedRequest extends Component {
    render() {

        return (
            <div>
                <Helmet title='Demandes' />
                <base href={this.props.location.pathname + '/'}/>
                <Grid>
                    <Elm src={SimplifiedRequestComponent.Elm.SimplifiedRequest} flags={{apiUrl: config.api.url, icons: Object.entries(icons)}}/>
                </Grid>
            </div>
            )
    }
}

export default connect()(SimplifiedRequest)


// WEBPACK FOOTER //
// ./lib/simplifiedRequest/SimplifiedRequest.js